import fp from 'lodash/fp';

import { getTimeStamp } from '../../webcommon/common/helpers';
import * as types from '../../webcommon/header/filterheader/propTypes';

import { combineColumnPreferences } from '../../common/saveconfiguration/utils';
import * as actions from './actions';
import makeColumns from './mappings';


export const INITIAL_STATE = {
    initialised: false,
    columns: makeColumns(false),
    imSummaries: [],
    lastUpdated: getTimeStamp(),
    unfilteredSummaries: [],
    loading: false,
    gridSorting: [],
    currentServerFilters: null,
    useDollars: false
};

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED: {
            return {
                ...state,
                initialised: true,
                loading: false
            };
        }
        case actions.FETCH_IMSUMMARIES_SUCCEEDED: {
            return {
                ...state,
                imSummaries: action.data,
                unfilteredSummaries: action.data,
                lastUpdated: getTimeStamp(),
                loading: false,
                currentServerFilters: action.serverFilters
            };
        }
        case actions.FETCH_IMSUMMARIES_FAILED: {
            return {
                ...state,
                imSummaries: [],
                loading: false
            };
        }
        case actions.SET_LOADING: {
            return {
                ...state,
                loading: true
            };
        }
        case actions.APPLY_CLIENT_FILTERS: {
            return fp.set(
                'imSummaries',
                fp.reduce((rows, filter) => fp.filter((row) => {
                    switch (filter.definition.type) {
                        case types.filterTypes.number:
                        {
                            const value = row[filter.definition.id];
                            const pass = filter.value.from === null || value >= filter.value.from;
                            return pass && (filter.value.to === null || value <= filter.value.to);
                        }
                        case types.filterTypes.list:
                            if (filter.definition.id === 'status') {
                                return filter.value.includes(fp.get('status')(row[filter.definition.id]));
                            }
                            return filter.value.includes(row[filter.definition.id]);
                        default:
                        {
                            return filter.value.includes(row[filter.definition.id]);
                        }
                    }
                })(rows))(state.unfilteredSummaries)(action.clientFilters),
                state
            );
        }
        case actions.SET_MONITORING_SUMMARIES_COLUMNS: {
            return {
                ...state,
                columns: combineColumnPreferences(makeColumns(state.useDollars), action.data)
            };
        }
        case actions.SET_DEFAULT_CONFIG: {
            return {
                ...state,
                columns: action.columns && action.columns.length
                    ? combineColumnPreferences(makeColumns(state.useDollars), action.columns)
                    : makeColumns(state.useDollars)
            };
        }
        case actions.SET_GRID_SORTS: {
            return fp.set('gridSorting', action.sorting)(state);
        }
        case actions.SET_ALL_GRID_SORTS: {
            return fp.set('gridSorting', action.data)(state);
        }
        case actions.SWITCH_CURRENCIES: {
            const currencyString = !state.useDollars ? 'Usd' : 'Eur';
            return {
                ...state,
                useDollars: !state.useDollars,
                columns: state.columns.map((column) => {
                    const idWithoutCurrency = fp.get('idWithoutCurrency')(column);
                    if (idWithoutCurrency) {
                        return {
                            ...column,
                            id: `${idWithoutCurrency}${currencyString}`
                        };
                    }
                    return column;
                })
            };
        }
        default:
            return state;
    }
}
